
import { makeStyles } from '@material-ui/core/styles';
import { BorderTop } from '@material-ui/icons';
import styled from 'styled-components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',

    },
  },

  bookingsTotalTitle: {
    letterSpacing: '0.035em',
    fontWeight: 'bold',
    lineHeight: '14px',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },

  tabContentWrapper: {
    padding: '24px 20px 22px 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 10px 14px 10px',
      borderTop: '1px solid #E5E5E5',
     
    },
  },
}));

export const TabsRoot = styled.div`
  flex: 1 1 auto;
  display: flex;
  @media (max-width: 600px) {
    flex-direction: column;
   
  }
`;

export default useStyles;

